// @ts-nocheck
export const localeCodes =  [
  "lt",
  "en",
  "ru"
]
export const localeLoaders = {
  lt: [
    {
      key: "locale_lt_46json_7b2fd1ef",
      load: () => import("#nuxt-i18n/7b2fd1ef" /* webpackChunkName: "locale_lt_46json_7b2fd1ef" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_e4a1079c",
      load: () => import("#nuxt-i18n/e4a1079c" /* webpackChunkName: "locale_en_46json_e4a1079c" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_b3e91306",
      load: () => import("#nuxt-i18n/b3e91306" /* webpackChunkName: "locale_ru_46json_b3e91306" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "lt",
    iso: "lt-LT",
    language: undefined
  },
  {
    code: "en",
    iso: "en-US",
    language: undefined
  },
  {
    code: "ru",
    iso: "ru-RU",
    language: undefined
  }
]
/** client **/

/** client-end **/